"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_values_1 = __importDefault(require("lodash.values"));

function values(obj) {
  return lodash_values_1.default(obj);
}

exports.values = values;